import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { RegisterAccess } from "../Entities/RegisterAccess";
import { IpInfoResponse } from "../interface/IpInfoResponse";
import { AnalistaDataService } from "../../../services/v1/AnalistaController/analista-data.service";
import { catchError, timeout } from "rxjs/operators";
import { of } from "rxjs";

@Injectable({
  providedIn: 'root',
})
export class RegistrarAcessoService {
  private ultimoRegistro: { cliente: string, timestamp: number } | null = null;
  private readonly DEBOUNCE_TIME = 5000; // 5 segundos

  constructor(private http: HttpClient,
    private analistaService: AnalistaDataService
  ) {

  }

  public registerUserIP(cliente: any) {
    // Verificar se já registrou recentemente para o mesmo cliente
    const clienteId = cliente?.negocio?.id || 'login';
    const agora = Date.now();
    
    // Log detalhado para debug
    
    if (this.ultimoRegistro && 
        this.ultimoRegistro.cliente === clienteId && 
        (agora - this.ultimoRegistro.timestamp) < this.DEBOUNCE_TIME) {
    
      return;
    }
    
    this.ultimoRegistro = { cliente: clienteId, timestamp: agora };

    let regAcesso: RegisterAccess = new RegisterAccess();

    if (cliente != null) {
      regAcesso.negocioId = cliente.negocio?.id ?? cliente.idNegocio ?? null;
      regAcesso.nomeCliente = cliente.nomeCliente;
    }

    // Registrar o acesso básico primeiro
    this.registrarAcessoBasico(regAcesso);

    // Tentar obter localização (opcional - não bloqueia o registro)
    this.http.get<IpInfoResponse>('https://api.ipify.org/?format=json')
      .pipe(
        timeout(5000), // 5 segundos de timeout
        catchError(error => {
          
          return of(null); // Retorna observable vazio para não quebrar o fluxo
        })
      )
      .subscribe(data => {
        if (data) {
          regAcesso.ip = data.ip;
          this.registerUserIpLocation(regAcesso);
        }
      });
  }

  // Método de teste para verificar se o sistema está funcionando
  public testarRegistroAcesso() {
    
    
    let regAcesso: RegisterAccess = new RegisterAccess();
    regAcesso.userName = 'Teste Sistema';
    regAcesso.email = 'teste@sistema.com';
    regAcesso.ip = '127.0.0.1';
    regAcesso.statusLocalizacao = 'Teste de sistema';
    
    this.registrarAcessoBasico(regAcesso);
  }

  private registrarAcessoBasico(regAcesso: RegisterAccess) {
    // Registrar acesso básico SEMPRE, independente de APIs externas
    
    
    
    
    this.analistaService.RegistraAcesso(regAcesso).subscribe(
      value => {
        
      },
      error => {
        console.error('❌ [FRONTEND] ERRO CRÍTICO ao registrar acesso:', error);
        // Tentar novamente após 2 segundos
        setTimeout(() => {
          
          this.analistaService.RegistraAcesso(regAcesso).subscribe(
            retryValue => {
              
            },
            retryError => {
              
            }
          );
        }, 2000);
      }
    );
  }

  private registerUserIpLocation(regAcesso: RegisterAccess) {
    

    this.http.get<IpInfoResponse>('https://ipapi.co/' + regAcesso.ip + '/json/')
      .pipe(
        timeout(5000), // 5 segundos de timeout
        catchError(error => {
          
          regAcesso.statusLocalizacao = 'Erro ao obter a posição';
          // NÃO registrar novamente aqui - já foi registrado no método básico
          return of(null);
        })
      )
      .subscribe(data => {
        if (data) {
          regAcesso.countryName = data.country_name;
          regAcesso.regionCode = data.region_code;
          regAcesso.regionName = data.region;
          regAcesso.city = data.city;
          regAcesso.latitude = Number.parseFloat(data.latitude);
          regAcesso.longitude = Number.parseFloat(data.longitude);
          regAcesso.statusLocalizacao = 'Posição obtida';

          
          
          

          // PROBLEMA IDENTIFICADO: Esta segunda chamada está causando a duplicação!
          // Vou comentar temporariamente para testar
          
          
          
          // Atualizar o registro existente com localização completa
          // this.analistaService.RegistraAcesso(regAcesso).subscribe(
          //   value => {
          //     console.log('✅ [FRONTEND] Acesso atualizado com localização completa');
          //   },
          //   error => {
          //     console.error('❌ [FRONTEND] Erro ao atualizar acesso com localização:', error);
          //   }
          // );
        }
      });
  }
}
